import React, { Component } from "react";

class TimeOut extends Component {
    render() {
        return (
            <div className="model-container model-center model-backdrop-show">
                <div
                    aria-labelledby="model-title"
                    aria-describedby="model-content"
                    className="model-popup model-modal model-show"
                    role="dialog"
                    aria-live="assertive"
                    aria-modal="true"
                >
                    <div className="model-header">
                        <img src="/images/timerModal.png" alt=""></img>
                    </div>
                    <h2 className="model-title" id="model-title">
                        Are you still there?
                    </h2>
                    <div className="model-content">
                        <div
                            id="model-content"
                            onClick={this.props.toggleTimeOutModal}
                            className=" text-center model-html-container"
                        >
                            Please click to verify. Otherwise your test will
                            become inactive in{" "}
                            <span id="timeOutCount">
                                {60 + this.props.timeOut}
                            </span>{" "}
                            seconds
                        </div>
                        <div
                            className="model-validation-message"
                            id="model-validation-message"
                        ></div>
                    </div>
                </div>
            </div>
        );
    }
}
export default TimeOut;



// WEBPACK FOOTER //
// ./src/components/writer/quiz/TimeOut.js